// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4o-0";
export var orangeButton = "_4o-1";